import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../stores/root-store-context';
import type { IProject } from '../../model/project';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useProjectsResult {
    isLoaded: boolean;
    projects: IProject[] | null;
}

export const useProjects = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState(() => ({
        isLoaded: true,
        projects: []
    } as useProjectsResult));

    useEffect(() => {
        setResult({ isLoaded: false, projects: [] });

        rootStore.projectStore.loadProjects()
            .then(() => {
                setResult({ isLoaded: true, projects: rootStore.projectStore.projects });
            })
            .catch(e => {
                    console.log(e);
                    publishNotification({
                        text: 'Error Loading Projects',
                        canClose: true
                    });
                }
            );
    }, [publishNotification, rootStore.projectStore]);

    return result;
};
